import * as React from 'react';
import Button from '@mui/material/Button';

export default function BasicButtons({title, handleAction}){
	return(
		<Button variant="contained" size="Large" sx={{width: '100%', p: "0.8rem"}} onClick={handleAction}>{title}</Button>
	);
}